import { createApp } from "vue";
import App from "./App.vue";
import router from "@/utils/router.js";

createApp(App).use(router).mount("#app"); // Asegúrate de que estás añadiendo el router aquí
